import type { ComponentPropsWithRef } from 'react';

import classnames from '../../core/utils/classnames.tsx';

interface UsageMeterProps extends ComponentPropsWithRef<'div'> {
    percent: number;
}

const fillColor = (percent: number) => {
    if (percent >= 100) return 'bg-surface-danger-strong';
    if (percent >= 80) return 'bg-surface-warning-strong';
    return 'bg-surface-brand-strong-default';
};

// thin meter (track + fill, no number); turns amber from 80 % and red at 100 %
export const UsageMeter = ({ percent, className, ...props }: UsageMeterProps) => {
    const clamped = Math.max(0, Math.min(100, Math.round(percent)));
    return (
        <div className={classnames('h-1.5 overflow-hidden rounded-full bg-surface-strong', className)} {...props}>
            <div className={classnames('h-full rounded-full', fillColor(clamped))} style={{ width: `${clamped}%` }} />
        </div>
    );
};
